import styled from 'styled-components'

import { useGetCensored } from '../../hooks/useGetCensored'

const Form = () => (
  <form
    action="https://beyondthepines.us7.list-manage.com/subscribe/post?u=53e7a73708dbdbc58064f2b19&amp;id=74141a43b3"
    method="post"
    target="_blank"
  >
    <Input
      id="name"
      name="EMAIL"
      placeholder="EMAIL ADDRESS"
      type="text"
      autoComplete="name"
      required
    />
    <div className="hide-tag">
    <input type="hidden" name="tags" value="10697614" />
    </div>
    <Button type="submit">GET EXCLUSIVE ACCESS</Button>
  </form>
)

const HolidayNewsletter = () => {
  const drops = useGetCensored({ limit: 4 })

  return (
    <>
      <Container>
        <H1>Exciting news! We have new exclusive content and deals for the holidays</H1>
        <Content>
          <FormContainer>
            <Form />
          </FormContainer>
          <p>
            Sign up now to be the first to know when they’re live!
          </p>
        </Content>
        <ImageContainer>
          {drops.map((drop) => (
            <Image key={drop} src={drop?.image} alt="drop1" />
          ))}
        </ImageContainer>
        <Logo src="/images/btp-logo.png" alt="logo" />
        <Icon src="/images/mailchimp-icon.png" alt="icon" />
      </Container>
    </>
  )
}

export default HolidayNewsletter

const H1 = styled.h1`
  color: #fff;
  text-align: center;
  padding: 20px 0;
  font-size: 2em;
  font-family: 'Soehne-Kraftig';
  @media (max-width: 420px) {
    font-size: 1.6em;
    padding: 20px 0 10px 0;
  }
`

const Container = styled.div`
  background-color: #364333;
  font-family: 'Soehne-XLeicht';

  h1 {
    font-family: 'Soehne-Kraftig';
  }

  p {
    font-size: 1.3em;
    margin: 15px 0;
  }

  strong {
    font-family: 'Soehne-Kraftig';
  }

  --shadow-color: 109deg 19% 11%;
  box-shadow: 0.3px 0.5px 0.7px hsl(var(--shadow-color) / 0.34),
    1.5px 2.9px 3.7px -0.4px hsl(var(--shadow-color) / 0.34),
    2.7px 5.4px 6.8px -0.7px hsl(var(--shadow-color) / 0.34),
    4.5px 8.9px 11.2px -1.1px hsl(var(--shadow-color) / 0.34),
    7.1px 14.3px 18px -1.4px hsl(var(--shadow-color) / 0.34),
    11.2px 22.3px 28.1px -1.8px hsl(var(--shadow-color) / 0.34),
    17px 33.9px 42.7px -2.1px hsl(var(--shadow-color) / 0.34),
    25px 50px 62.9px -2.5px hsl(var(--shadow-color) / 0.34);

  @media (max-width: 420px) {
    margin: 0 auto;
    padding: 0 12px;
  }
`

const ImageContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 15px;
  justify-content: center;

  @media (max-width: 420px) {
    flex-wrap: wrap;
  }
`

const FormContainer = styled.div`
  width: 75%;
  margin: 0 auto;

  @media (max-width: 420px) {
    width: 100%;
  }
`

const Image = styled.img`
  width: 30%;
  height: 500px;
  object-fit: cover;

  @media (max-width: 420px) {
    width: 48%;
    height: 300px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;
  text-align: center;
  gap: 12px;
  padding: 12px;
  @media (max-width: 420px) {
    z-index: 2;
    padding: 0 12px;
  }
`

const Button = styled.button`
  margin-top: 15px;
  color: #364333;
  background: #fff;
  border-radius: 60px;
  &:hover {
    background: #000;
    color: #fff;
  }
`

const Input = styled.input`
  padding: 4px 6px;
  margin-top: 12px;
  color: #000;
  padding: 10px 5px;
  border-radius: 8px;
`

const Logo = styled.img`
  width: 120px;
  margin: 20px auto 0px auto;
  filter: invert();
`

const Icon = styled.img`
  width: 80px;
  margin: 0 auto;
`
